__turbopack_context__.v({
  "form": "search-form-module__xisAca__form",
  "input": "search-form-module__xisAca__input",
  "srOnly": "search-form-module__xisAca__srOnly",
});
